import { httpPut } from "../utils/http";
import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  sendExamTaskRequest(docID, optUserID) {
    let data = { optUserID };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/todo/exam/${Crypto.encrypt(docID, CryptoKey)}/request`;
    return httpPut(apiUrl, data);
  }

  updateExamTask(
    docID,
    mergedResult,
    finishTask,
    resetTask,
    submit,
    optUserID,
    settingTask = []
  ) {
    let data = {
      mergedResult,
      finishTask,
      resetTask,
      submit,
      optUserID,
      settingTask,
    };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/todo/exam/${Crypto.encrypt(docID, CryptoKey)}`;
    return httpPut(apiUrl, data);
  }

  updateOutsourcingTask(docID, task, taskFiles, submit, optUserID) {
    let data = { task, taskFiles, submit, optUserID };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/todo/outsourcing/${Crypto.encrypt(docID, CryptoKey)}`;
    return httpPut(apiUrl, data);
  }
  updateInsideTask(docID, task, taskFiles, submit, optUserID) {
    let data = { task, taskFiles, submit, optUserID };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/todo/inside/${Crypto.encrypt(docID, CryptoKey)}`;
    return httpPut(apiUrl, data);
  }
  updateDrugDispense(docID, drugBagIDs, drugDispensedBy, optUserID, onlySave, submit = false) {
    let data = { drugBagIDs, drugDispensedBy, optUserID, onlySave, submit, };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/todo/dispense/${Crypto.encrypt(docID, CryptoKey)}`;
    return httpPut(apiUrl, data);
  }
}
